import React from "react";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";

interface CommonHeaderProps {
  title: string;
  description: string;
  // Option 1: Use onNavigate callback with section string
  onNavigate?: (section: string) => void;
  navigateTo?: string;
  // Option 2: Use direct onClick handler
  onClick?: () => void;
  // Button configuration
  buttonText?: string;
  buttonIcon?: React.ComponentType<{ className?: string }>;
  showButton?: boolean;
}

export default function CommonHeader({
  title,
  description,
  onNavigate,
  navigateTo,
  onClick,
  buttonText = "New Appointment",
  buttonIcon: ButtonIcon = Plus,
  showButton = true,
}: CommonHeaderProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (onNavigate && navigateTo) {
      onNavigate(navigateTo);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      </div>
      {showButton && (onClick || (onNavigate && navigateTo)) && (
        <div className="flex gap-3">
          <Button onClick={handleClick} size="default" className="shadow-sm">
            <ButtonIcon className="mr-2 h-4 w-4" />
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
}
